import { IMacDetails, IMacKeyword, MacStageKey } from "@models/MacDetails";
import MacChartKeyword from "../MacChartKeyword/MacChartKeyword";
import MacChartStageFooter from "../MacChartStageFooter/MacChartStageFooter";
import { MAC_CANVAS_WIDTH, MAC_CURVE_PATH, MAC_CURVE_STROKE_WIDTH, MAC_CURVE_VIEW_BOX, MAC_STAGE_META } from "./MacChart.constants";
import { getChipStyleVars, getScaleStyleVars } from "./MacChart.helpers";
import { useMacChartScale } from "./useMacChartScale";
import "./MacChart.scss";

interface MacChartProps {
    mac: IMacDetails;
    selectedStages: MacStageKey[];
    selectedKeywordId: number | null;
    onToggleStage: (stage: MacStageKey) => void;
    onViewMenuExamples: (keyword: IMacKeyword) => void;
}

function MacChart({ mac, selectedStages, selectedKeywordId, onToggleStage, onViewMenuExamples }: MacChartProps) {
    const { frameRef, scale } = useMacChartScale(MAC_CANVAS_WIDTH);

    return (
        <div className="MacChart" ref={frameRef} style={getScaleStyleVars(scale)} data-testid="blockMacDetailsChart">
            <div className="MacChart__canvas" style={getChipStyleVars(mac.fontSize)}>
                <svg
                    className="MacChart__curve"
                    viewBox={MAC_CURVE_VIEW_BOX}
                    preserveAspectRatio="none"
                    aria-hidden
                >
                    <path d={MAC_CURVE_PATH} stroke="currentColor" strokeWidth={MAC_CURVE_STROKE_WIDTH} fill="none"/>
                </svg>
                <h2 className="MacChart__title" data-testid="textMacDetailsTitle">{mac.title}</h2>
                <div className="MacChart__columns">
                    {mac.stages.map((stage, stageIndex) => (
                        <div key={stage.key} className={`MacChart__column MacChart__column--${stage.key}`}>
                            <div className="MacChart__keywords">
                                {stage.keywords.map((keyword, keywordIndex) => (
                                    <MacChartKeyword
                                        key={keyword.id}
                                        keyword={keyword}
                                        testIdSuffix={`${stageIndex}-${keywordIndex}`}
                                        isSelected={keyword.id === selectedKeywordId}
                                        hasMenu={mac.hasKeywordMenu}
                                        // Food profiles cover US data only.
                                        hasFoodProfile={!mac.isNonUs && keyword.isKeyword}
                                        onViewMenuExamples={onViewMenuExamples}
                                    />
                                ))}
                            </div>
                            <MacChartStageFooter
                                stage={MAC_STAGE_META[stage.key]}
                                index={stageIndex}
                                isSelectable={!mac.isNonUs}
                                isSelected={selectedStages.includes(stage.key)}
                                onToggle={() => onToggleStage(stage.key)}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default MacChart;
